<div [formGroup]="formGroup" class="row" [ngClass]="{'form-disabled': readonly}">
    <ng-container *ngFor="let field of formFields">
        <div class="col-lg-4">
            <div class="row">
                <div class="col-lg-12">
                    <ng-container *ngIf="field.selectables != undefined">
                        <mat-form-field class="mat-form-field-fluid">
                            <mat-select 
                                [formControlName]="field.select_formControlName" 
                                [placeholder]="field.select_name">
                                <mat-option *ngFor="let item of field.selectables | async" [value]="item.id">
                                    {{item.name}}
                                </mat-option>
                            </mat-select>
                            <mat-error>
                                {{field.select_name}} <strong>required</strong>
                            </mat-error>
                        </mat-form-field>
                    </ng-container>
                    <ng-container *ngIf="!field.selectables">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput [formControlName]="field.select_formControlName" 
                                [placeholder]="field.select_name">
                            <mat-icon
                                    *ngIf="field.has_tooltip"
                                    matSuffix
                                    class="cursor-pointer"
                                    (click)="$event.stopPropagation();"
                                    container="body"
                                    [ngbPopover]="'TOOLTIP.HOUSE.WOODWORK.DESCRIPTION' | translate"
                                    [popoverTitle]="'TOOLTIP.HOUSE.WOODWORK.TITLE' | translate">help
                            </mat-icon>
                            <mat-error>
                                {{field.select_name}} <strong>required</strong>
                            </mat-error>
                        </mat-form-field>
                    </ng-container>
                </div>
                <div class="col-lg-12">
                    <mat-form-field class="mat-form-field-fluid">
                        <input matInput [formControlName]="field.comment_formControlName"
                            [placeholder]="field.comment_name" >
                    </mat-form-field>
                </div>
            </div>
        </div>
    </ng-container>

    <div class="col-lg-4" *ngIf="propertySubTypeID == 7 || propertySubTypeID == 11">
        <div class="row">
            <div class="col-lg-12">
                <mat-form-field class="mat-form-field-fluid">
                    <mat-select formControlName="loading_dock" placeholder="Loading docks">
                        <mat-option [value]="true">Yes</mat-option>
                        <mat-option [value]="false">No</mat-option>
                    </mat-select>
                    <mat-error>
                        Loading docks <strong>required</strong>
                    </mat-error>
                </mat-form-field>
            </div>
            <ng-container *ngIf="formGroup.controls.loading_dock.value">
                <div class="col-lg-12">
                    <mat-form-field class="mat-form-field-fluid">
                        <input matInput type="number" formControlName="loading_dock_num" placeholder="Number" />
                    </mat-form-field>
                </div>
                <div class="col-lg-12">
                    <mat-form-field class="mat-form-field-fluid">
                        <input matInput formControlName="loading_dock_comment" placeholder="Loading docks comments" />
                    </mat-form-field>
                </div>
            </ng-container>
        </div>
    </div>

    <div class="col-lg-12">
        <mat-checkbox formControlName="has_other">
            Other
        </mat-checkbox>
    </div>
    <div class="col-lg-12" *ngIf="formGroup.controls.has_other.value">
        <mat-form-field class="mat-form-field-fluid">
            <input matInput formControlName="other_aspects" placeholder="Please specify" />
            <mat-error>
                This field is <strong>required</strong>
            </mat-error>
        </mat-form-field>
    </div>
</div>

<!-- <button type="button" (click)="getData()">Submit</button> -->